module.exports = __webpack_public_path__ + "images/688d0c11.main-pic-chs.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/main-pic-chs.png
// module id = 382
// module chunks = 0